import Offers from '../offers/offers';

export default function OffersTab(props) {

    const projectId = props.projectId

return (
    <div>
        <Offers isInProject = {true} projectId = {projectId}></Offers>
    </div>
)};